import { ArtBoardNS } from "../../../../../../ArtBoard/ArtBoardNS.js";
import { BackgroundNS } from "../../../../../../Background/BackgroundNS.js";
import { CommonNS } from "../../../../../../Common/CommonNS.js";
import { GroupingNS } from "../../../../../../Grouping/GroupingNS.js";
import { LockingNS } from "../../../../../../Locking/LockingNS.js";
import { PathEditorNS } from "../../../../../../PathEditor/PathEditorNS.js";
import { RubberBandNS } from "../../../../../../RubberBand/RubberBandNS.js";
import { SelectionNS } from "../../../../../../Selection/SelectionNS.js";
import { SelectorNS } from "../../../../../../Selector/SelectorNS.js";
import { StrokeNS } from "../../../../../../Stroke/StrokeNS.js";
import { TransformNS } from "../../../../../../Transform/TransformNS.js";
import { ViewBoxNS } from "../../../../../../ViewBox/ViewBoxNS.js";
import { ViewPortNS } from "../../../../../../ViewPort/ViewPortNS.js";
import { WorkingLayerNS } from "../../../../../../WorkingLayer/WorkingLayerNS.js";
import { BaseNS } from "../../Base/BaseNS.js";
import { _checkIsPathEditing } from "../private/_checkIsPathEditing.js";
import { _checkNoProcessingTask } from "../private/_checkNoProcessingTask.js";
import { _getSelectionScaleTransform1Throwable } from "../private/_getSelectionScaleTransform1Throwable.js";
import { _getSelectionScaleTransform2Throwable } from "../private/_getSelectionScaleTransform2Throwable.js";
import { _handleTouchEndOrCancel } from "../private/_handleTouchEndOrCancel.js";
import { _handleTouchMove } from "../private/_handleTouchMove.js";
import { _handleTouchStartOnCanvasEl } from "../private/_handleTouchStartOnCanvasEl.js";
import { _handleTouchStartOnSelectorPathEl } from "../private/_handleTouchStartOnSelectorPathEl.js";
import { _handleTouchStartOnSelectorRotateCircleEl } from "../private/_handleTouchStartOnSelectorRotateCircleEl.js";
import { _handleTouchStartOnSelectorScaleCircleEl } from "../private/_handleTouchStartOnSelectorScaleCircleEl.js";
import { calculateViewBoxFitToArtBoard } from "../private/calculateViewBoxFitToArtBoard.js";
import { PROCESSING_TASK } from "../private/const.js";
import { destroy } from "../private/destroy.js";
import { endEditPath } from "../private/endEditPath.js";
import { initEditor } from "../private/initEditor.js";
import { startEditPath } from "../private/startEditPath.js";
export class SingleStickerMobileEditor {
  constructor({ window, document, touch_margin, all_scalable_node_name_set }) {
    this._window = window;
    this._document = document;
    this._svg_el = document.createElementNS(
      CommonNS.ConstNS.SVG_NAMESPACE,
      "svg"
    );
    this._transform_manipulator = new TransformNS.ModelNS.TransformManipulator({
      svg_el: this._svg_el.cloneNode(),
    });
    this._touch_margin = touch_margin;
    this._all_scalable_node_name_set =
      all_scalable_node_name_set ?? new Set(["path"]);
    this._container_el = null;
    this._canvas_el = null;
    this._dummy_g_el = null;
    this._layers_el = null;
    this._art_board_layer_el = null;
    this._background_layer_el = null;
    this._working_layer_el = null;
    this._foreground_layer_el = null;
    this._rubber_band_layer_el = null;
    this._path_editor_layer_el = null;
    this._art_board_rect_el = null;
    this._art_board_filter_drop_shadow_el = null;
    this._background_base_el = null;
    this._background_color_el = null;
    this._background_image_el = null;
    this._selector_path_el = null;
    this._selector_nw_circle_el = null;
    this._selector_n_circle_el = null;
    this._selector_ne_circle_el = null;
    this._selector_e_circle_el = null;
    this._selector_se_circle_el = null;
    this._selector_s_circle_el = null;
    this._selector_sw_circle_el = null;
    this._selector_w_circle_el = null;
    this._selector_r_circle_el = null;
    this._rubber_band_el = null;
    this._path_editor_line_container_el = null;
    this._path_editor_point_container_el = null;
    this._view_port = null;
    this._view_box = null;
    this._working_layer = null;
    this._art_board = null;
    this._background = null;
    this._selector_controller = null;
    this._rubber_band = null;
    this._grouping = null;
    this._locking = null;
    this._selection = null;
    this._selection_translate_transform = null;
    this._selection_scale_transform1 = null;
    this._selection_scale_transform2 = null;
    this._selection_rotate_transform = null;
    this._translate_transform = null;
    this._scale_transform = null;
    this._stroke = null;
    this._stroke_sync = null;
    this._processing_task = null;
    this._path_editor_target_el = null;
    this._path_editor_list = [];
    this._path_editor_point_size_controller = null;
    this._touchStartOnCanvasElHandler = null;
    this._touchStartOnSelectorPathElHandler = null;
    this._touchStartOnSelectorScaleNCircleElHandler = null;
    this._touchStartOnSelectorScaleNECircleElHandler = null;
    this._touchStartOnSelectorScaleECircleElHandler = null;
    this._touchStartOnSelectorScaleSECircleElHandler = null;
    this._touchStartOnSelectorScaleSCircleElHandler = null;
    this._touchStartOnSelectorScaleSWCircleElHandler = null;
    this._touchStartOnSelectorScaleWCircleElHandler = null;
    this._touchStartOnSelectorScaleNWCircleElHandler = null;
    this._touchStartOnSelectorRotateCircleElHandler = null;
    this._touchMoveHandler = null;
    this._touchEndOrCancelHandler = null;
    this._touch_map = new Map();
    this._selecting_touch_id = null;
    this._translate_transforming_touch_id = null;
    this._scale_transforming1_touch_id = null;
    this._scale_transforming2_touch_id1 = null;
    this._scale_transforming2_touch_id2 = null;
    this._rotate_transforming_origin_x = 0;
    this._rotate_transforming_origin_y = 0;
    this._rotate_transforming_touch_id = null;
    this._zooming_and_panning_touch_id1 = null;
    this._zooming_and_panning_progress_touch_x1 = 0;
    this._zooming_and_panning_progress_touch_y1 = 0;
    this._zooming_and_panning_touch_id2 = null;
    this._zooming_and_panning_progress_touch_x2 = 0;
    this._zooming_and_panning_progress_touch_y2 = 0;
    this._path_editing_touch_id = null;
    this._path_editing_progress_touch_x = 0;
    this._path_editing_progress_touch_y = 0;
  }
  initDOM() {
    return BaseNS.initDOM(this);
  }
  initEditor() {
    return initEditor(this);
  }
  destroy() {
    return destroy(this);
  }
  appendTo(el) {
    return BaseNS.appendTo(this, el);
  }
  fitSize() {
    return BaseNS.fitSize(this);
  }
  setArtBoardSize(size) {
    return BaseNS.setArtBoardSize(this, size);
  }
  turnOnArtBoardClipPath() {
    return BaseNS.turnOnArtBoardClipPath(this);
  }
  turnOffArtBoardClipPath() {
    return BaseNS.turnOffArtBoardClipPath(this);
  }
  calculateViewBoxFitToArtBoard(config) {
    return calculateViewBoxFitToArtBoard(this, config);
  }
  setViewBox(view_box_vo) {
    return BaseNS.setViewBox(this, view_box_vo);
  }
  getGraphicsEls() {
    return BaseNS.getGraphicsEls(this);
  }
  addEl(el) {
    return BaseNS.addEl(this, el);
  }
  selectEls(el_list) {
    return BaseNS.selectEls(this, el_list);
  }
  selectEl(el) {
    return BaseNS.selectEl(this, el);
  }
  unselectEl(el) {
    return BaseNS.unselectEl(this, el);
  }
  showEl(el) {
    return BaseNS.showEl(this, el);
  }
  hideEl(el) {
    return BaseNS.hideEl(this, el);
  }
  getSelectedEls() {
    return BaseNS.getSelectedEls(this);
  }
  syncSelectorWithSelection() {
    return BaseNS.syncSelectorWithSelection(this);
  }
  removeEl(el) {
    return BaseNS.removeEl(this, el);
  }
  copyEl(el) {
    return BaseNS.copyEl(this, el);
  }
  getIsGroupEl(el) {
    return BaseNS.getIsGroupEl(this, el);
  }
  groupEls(els) {
    return BaseNS.groupEls(this, els);
  }
  ungroupEl(g_el) {
    return BaseNS.ungroupEl(this, g_el);
  }
  getLockedEls() {
    return BaseNS.getLockedEls(this);
  }
  getIsLocked(el) {
    return BaseNS.getIsLocked(this, el);
  }
  lockEl(el) {
    return BaseNS.lockEl(this, el);
  }
  unlockEl(el) {
    return BaseNS.unlockEl(this, el);
  }
  moveForward(el) {
    return BaseNS.moveForward(this, el);
  }
  moveBackward(el) {
    return BaseNS.moveBackward(this, el);
  }
  flipHorizontal(el) {
    return BaseNS.flipHorizontal(this, el);
  }
  flipVertical(el) {
    return BaseNS.flipVertical(this, el);
  }
  alignToLeftEnd(els) {
    return BaseNS.alignToLeftEnd(this, els);
  }
  alignToRightEnd(els) {
    return BaseNS.alignToRightEnd(this, els);
  }
  alignToTopEnd(els) {
    return BaseNS.alignToTopEnd(this, els);
  }
  alignToBottomEnd(els) {
    return BaseNS.alignToBottomEnd(this, els);
  }
  alignToHorizontalCenter(els) {
    return BaseNS.alignToHorizontalCenter(this, els);
  }
  alignToVerticalCenter(els) {
    return BaseNS.alignToVerticalCenter(this, els);
  }
  scaleWithinArtBoard(payload) {
    return BaseNS.scaleWithinArtBoard(this, payload);
  }
  setStrokeWidth({ el, stroke_width }) {
    return BaseNS.setStrokeWidth(this, {
      el,
      stroke_width,
    });
  }
  setStrokeDasharray({ el, stroke_dasharray }) {
    return BaseNS.setStrokeDasharray(this, {
      el,
      stroke_dasharray,
    });
  }
  getBackground() {
    return BaseNS.getBackground(this);
  }
  setBackground(value) {
    return BaseNS.setBackground(this, value);
  }
  setForeground(el) {
    return BaseNS.setForeground(this, el);
  }
  startEditPath(path_el) {
    return startEditPath(this, path_el);
  }
  getActivePathCommand() {
    return BaseNS.getActivePathCommand(this);
  }
  getPrevPathCommand(ref_command) {
    return BaseNS.getPrevPathCommand(this, ref_command);
  }
  getNextPathCommand(ref_command) {
    return BaseNS.getNextPathCommand(this, ref_command);
  }
  getClosePathCommandList() {
    return BaseNS.getClosePathCommandList(this);
  }
  insertPathEditorBefore({ ref_command, makePathEditor }) {
    return BaseNS.insertPathEditorBefore(this, {
      ref_command,
      makePathEditor,
    });
  }
  replacePathCommand({ ref_command, makePathEditor }) {
    return BaseNS.replacePathCommand(this, {
      ref_command,
      makePathEditor,
    });
  }
  removePathCommand(command) {
    return BaseNS.removePathCommand(this, command);
  }
  endEditPath() {
    return endEditPath(this);
  }
  exportEditor(payload) {
    return BaseNS.exportEditor(this, payload);
  }
  _handleTouchStartOnCanvasEl(event) {
    return _handleTouchStartOnCanvasEl(this, event);
  }
  _handleTouchStartOnSelectorPathEl(event) {
    return _handleTouchStartOnSelectorPathEl(this, event);
  }
  _handleTouchStartOnSelectorScaleCircleEl(event_payload) {
    return _handleTouchStartOnSelectorScaleCircleEl(this, event_payload);
  }
  _handleTouchStartOnSelectorRotateCircleEl(event) {
    return _handleTouchStartOnSelectorRotateCircleEl(this, event);
  }
  _handleTouchMove(event) {
    return _handleTouchMove(this, event);
  }
  _handleTouchEndOrCancel(event) {
    return _handleTouchEndOrCancel(this, event);
  }
  _getSelectorCenterPointInViewPort() {
    return BaseNS._getSelectorCenterPointInViewPort(this);
  }
  _getContainerElThrowable() {
    return BaseNS._getContainerElThrowable(this);
  }
  _getCanvasElThrowable() {
    return BaseNS._getCanvasElThrowable(this);
  }
  _getDummyGElThrowable() {
    return BaseNS._getDummyGElThrowable(this);
  }
  _getLayersElThrowable() {
    return BaseNS._getLayersElThrowable(this);
  }
  _getArtBoardLayerElThrowable() {
    return BaseNS._getArtBoardLayerElThrowable(this);
  }
  _getBackgroundLayerElThrowable() {
    return BaseNS._getBackgroundLayerElThrowable(this);
  }
  _getWorkingLayerElThrowable() {
    return BaseNS._getWorkingLayerElThrowable(this);
  }
  _getForegroundLayerElThrowable() {
    return BaseNS._getForegroundLayerElThrowable(this);
  }
  _getRubberBandLayerElThrowable() {
    return BaseNS._getRubberBandLayerElThrowable(this);
  }
  _getPathEditorLayerElThrowable() {
    return BaseNS._getPathEditorLayerElThrowable(this);
  }
  _getArtBoardRectElThrowable() {
    return BaseNS._getArtBoardRectElThrowable(this);
  }
  _getArtBoardFilterDropShadowElThrowable() {
    return BaseNS._getArtBoardFilterDropShadowElThrowable(this);
  }
  _getArtBoardClipPathElThrowable() {
    return BaseNS._getArtBoardClipPathElThrowable(this);
  }
  _getArtBoardClipPathRectElThrowable() {
    return BaseNS._getArtBoardClipPathRectElThrowable(this);
  }
  _getBackgroundBaseElThrowable() {
    return BaseNS._getBackgroundBaseElThrowable(this);
  }
  _getBackgroundColorElThrowable() {
    return BaseNS._getBackgroundColorElThrowable(this);
  }
  _getBackgroundImageElThrowable() {
    return BaseNS._getBackgroundImageElThrowable(this);
  }
  _getSelectorPathElThrowable() {
    return BaseNS._getSelectorPathElThrowable(this);
  }
  _getSelectorNWCircleElThrowable() {
    return BaseNS._getSelectorNWCircleElThrowable(this);
  }
  _getSelectorNCircleElThrowable() {
    return BaseNS._getSelectorNCircleElThrowable(this);
  }
  _getSelectorNECircleElThrowable() {
    return BaseNS._getSelectorNECircleElThrowable(this);
  }
  _getSelectorECircleElThrowable() {
    return BaseNS._getSelectorECircleElThrowable(this);
  }
  _getSelectorSECircleElThrowable() {
    return BaseNS._getSelectorSECircleElThrowable(this);
  }
  _getSelectorSCircleElThrowable() {
    return BaseNS._getSelectorSCircleElThrowable(this);
  }
  _getSelectorSWCircleElThrowable() {
    return BaseNS._getSelectorSWCircleElThrowable(this);
  }
  _getSelectorWCircleElThrowable() {
    return BaseNS._getSelectorWCircleElThrowable(this);
  }
  _getSelectorRCircleElThrowable() {
    return BaseNS._getSelectorRCircleElThrowable(this);
  }
  _getRubberBandElThrowable() {
    return BaseNS._getRubberBandElThrowable(this);
  }
  _getPathEditorLineContainerElThrowable() {
    return BaseNS._getPathEditorLineContainerElThrowable(this);
  }
  _getPathEditorPointContainerElThrowable() {
    return BaseNS._getPathEditorPointContainerElThrowable(this);
  }
  _getViewPortThrowable() {
    return BaseNS._getViewPortThrowable(this);
  }
  _getViewBoxThrowable() {
    return BaseNS._getViewBoxThrowable(this);
  }
  _getWorkingLayerThrowable() {
    return BaseNS._getWorkingLayerThrowable(this);
  }
  _getArtBoardThrowable() {
    return BaseNS._getArtBoardThrowable(this);
  }
  _getBackgroundThrowable() {
    return BaseNS._getBackgroundThrowable(this);
  }
  _getSelectorControllerThrowable() {
    return BaseNS._getSelectorControllerThrowable(this);
  }
  _getRubberBandThrowable() {
    return BaseNS._getRubberBandThrowable(this);
  }
  _getGroupingThrowable() {
    return BaseNS._getGroupingThrowable(this);
  }
  _getLockingThrowable() {
    return BaseNS._getLockingThrowable(this);
  }
  _getSelectionThrowable() {
    return BaseNS._getSelectionThrowable(this);
  }
  _getSelectionTranslateTransformThrowable() {
    return BaseNS._getSelectionTranslateTransformThrowable(this);
  }
  _getSelectionScaleTransform1Throwable() {
    return _getSelectionScaleTransform1Throwable(this);
  }
  _getSelectionScaleTransform2Throwable() {
    return _getSelectionScaleTransform2Throwable(this);
  }
  _getSelectionRotateTransformThrowable() {
    return BaseNS._getSelectionRotateTransformThrowable(this);
  }
  _getTranslateTransformThrowable() {
    return BaseNS._getTranslateTransformThrowable(this);
  }
  _getScaleTransformThrowable() {
    return BaseNS._getScaleTransformThrowable(this);
  }
  _getStrokeThrowable() {
    return BaseNS._getStrokeThrowable(this);
  }
  _getStrokeSyncThrowable() {
    return BaseNS._getStrokeSyncThrowable(this);
  }
  _getPathEditorPointSizeControllerThrowable() {
    return BaseNS._getPathEditorPointSizeControllerThrowable(this);
  }
  _checkNoProcessingTask() {
    return _checkNoProcessingTask(this);
  }
  _checkIsPathEditing() {
    return _checkIsPathEditing(this);
  }
  _toViewPortPoint(point) {
    return BaseNS._toViewPortPoint(this, point);
  }
}
